var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"pass-rates-chart-loading text-center"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }